// @flow
import * as React from 'react';
import classnames from 'classnames';

import { Button } from 'Components/frameworks/button/Button.jsx';
import { Text } from 'Components/frameworks/text/Text.jsx';

type Props = {
  className?: string,
  text: string,
  link?: string,
  linkLabel?: string,
};

export function EmptyTripOverview(props: Props) {
  const { className, text, link, linkLabel } = props;
  return text ? (
    <div
      className={classnames(
        'TripOverview',
        'flex flex-col justify-center items-center p-4 text-center border-1 border-dotted rounded',
        className,
      )}
    >
      <Text text={text} />
      {link ? (
        <Button className="w-full mt-4" url={link}>
          {linkLabel}
        </Button>
      ) : null}
    </div>
  ) : null;
}
